/* Client-side PII validation hook (Tier 1) */

export interface PIIValidationResult {
  isValid: boolean;
  reason?: string;
  detectedType?: string;
}

export const usePIIValidation = () => {
  const validateQuery = (query: string): PIIValidationResult => {
    if (!query || query.trim().length === 0) {
      return { isValid: true };
    }

    // Tier 1: Client-side regex patterns
    const patterns: Record<string, { regex: RegExp; description: string }> = {
      // Basic PII
      phone: {
        regex: /\b\d{3}[-.\s]?\d{3}[-.\s]?\d{4}\b/,
        description: 'phone number',
      },
      email: {
        regex: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/,
        description: 'email address',
      },
      ssn: {
        regex: /\b\d{3}[-\s]?\d{2}[-\s]?\d{4}\b/,
        description: 'Social Security Number',
      },

      // HIPAA-specific patterns
    };

    for (const [type, { regex, description }] of Object.entries(patterns)) {
      if (regex.test(query)) {
        return {
          isValid: false,
          reason: `Please remove ${description} from your query for privacy.`,
          detectedType: type,
        };
      }
    }

    return { isValid: true };
  };

  return { validateQuery };
};
